import React, { createContext, useContext, useState, useCallback } from 'react';
import ModeratorActionModal from './components/ModeratorActionModal';

const ModeratorActionContext = createContext();

export const ModeratorActionProvider = ({ children }) => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    actionType: '',
    itemId: null,
  });

  const openModModal = useCallback((actionType, itemId) => {
    setModalState({ isOpen: true, actionType, itemId });
  }, []);

  const closeModModal = useCallback(() => {
    setModalState({ isOpen: false, actionType: '', itemId: null });
  }, []);

  return (
    <ModeratorActionContext.Provider value={{ openModModal }}>
      {children}
      <ModeratorActionModal
        show={modalState.isOpen}
        onHide={closeModModal}
        actionType={modalState.actionType}
        itemId={modalState.itemId}
      />
    </ModeratorActionContext.Provider>
  );
};

export const useModeratorAction = () => {
  const context = useContext(ModeratorActionContext);
  if (context === undefined) {
    throw new Error('useModeratorAction must be used within a ModeratorActionProvider');
  }
  return context;
};